import { hideCursors } from "../helpers-board.js";

function addCursors({ board, buttons, uiState, registerCleanup }) {
  if (uiState.cursorsActivated) return Promise.resolve();
  uiState.cursorsActivated = true;

  const cursorDiv = document.createElement("div");
  cursorDiv.classList.add("cursors");
  document.body.prepend(cursorDiv);
  const cursorDivRect = cursorDiv.getBoundingClientRect();


  function handleMouseMove(e) {
    cursorDiv.style.top = `${e.clientY - (cursorDivRect.height / 2)}px`;
    cursorDiv.style.left = `${e.clientX - (cursorDivRect.width / 2)}px`;
  }

  document.addEventListener('mousemove', handleMouseMove)

  hideCursors({ board, buttons });

  function cleanup(e) {
    // if (e.target.tagName !== "BUTTON") return;
    document.body.classList.remove("cursorless");
    board.classList.remove("cursorless");
    cursorDiv.remove();
    uiState.cursorsActivated = false;
    document.removeEventListener('mousemove', handleMouseMove);
  }

  // setTimeout(() => { board.addEventListener("click", cleanup) }, 1);
  registerCleanup(cleanup);

}

export default addCursors;
